<template>
    <div class="reo-collapse">
        <collapse-item
            v-for="(item, index) in data"
            :key="index"
            :id="index"
            :title="item.title"
            :content="item.content"
            :defaultActive="activeId"
            :currentActive="activeId"
            :accordion="accordion"
            @collapsed="handleCollapsed"
        ></collapse-item>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import CollapseItem from './CollapseItem.vue';

interface ICollapseItemData {
    title: string;
    content: string;
    id: number;
    collapsed: boolean;
}

export default Vue.extend({
    components: {
        CollapseItem
    },
    props: {
        data: Array as PropType<ICollapseItemData[]>,
        accordion: {
            type: Boolean,
            default: true
        }
    },
    data() {

        return {
            activeId: 0
        };

    },
    methods: {
        handleCollapsed( isCollapsed: boolean, id: number ) {

            if ( !isCollapsed ) {

                this.activeId = id;

            }

        }
    }
});
</script>

<style lang="less">

</style>
